export class RavenToSentryAdapter {
    constructor(ravenClient) {
        this.ravenClient = ravenClient;
    }
    captureException(exception, options) {
        if (options?.contexts) {
            options = {
                ...options,
                extra: options.contexts,
            };
        }
        this.ravenClient.captureException(exception, options);
        return this.ravenClient.lastEventId();
    }
    captureMessage(message, options) {
        if (options?.contexts) {
            options = {
                ...options,
                extra: options.contexts,
            };
        }
        this.ravenClient.captureMessage(message, options);
        return this.ravenClient.lastEventId();
    }
    addBreadcrumb(breadcrumb) {
        return this.ravenClient.captureBreadcrumb(breadcrumb);
    }
}
//# sourceMappingURL=RavenToSentryAdapter.js.map